import React from "react";
import Page, { PageProps } from "../Page";
import { IReportingPeriodDetailsPresenter } from "../../../presenter/reporting/ReportingPeriodDetailsPresenter";
import Title from "antd/lib/typography/Title";
import ReportingPeriodOverview from "../../components/reporting/ReportingPeriodOverview";
import { Divider, Tabs } from "antd";
import DataGrid from "../../components/app/grid/DataGrid";
import { TReportingPeriodApplicantPresentationModel } from "../../../model/applicant/ReportingPeriodApplicantPresentationModel";
import { TGridAction } from "../../components/app/grid/GridActionsDropdown";
import TickBox from "../../components/app/grid/TickBox";

const { TabPane } = Tabs;

export interface Props extends PageProps {}

export interface State extends IReportingPeriodDetailsPresenter {}

export default class ReportingPeriodDetailsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      reportingPeriod,
      reportingPeriodApplicants,
      showApplicantDetails,
      canShowApplicantDetails
    } = this.state;

    const { applicantsLoader } = this.state.loaders;

    const applicantActions: TGridAction[] = [
      {
        label: translate("registered_applicant_page.details"),
        onClick: (record: TReportingPeriodApplicantPresentationModel) => (e) =>
          showApplicantDetails(record.applicantId),
        type: "primary"
      }
    ];

    const applicantColumns = [
      {
        title: translate("reporting_period_details_page.first_name"),
        dataIndex: "firstName",
        key: "firstName"
      },
      {
        title: translate("reporting_period_details_page.last_name"),
        dataIndex: "lastName",
        key: "lastName"
      },
      {
        title: translate(
          "reporting_period_details_page.party_personal_identification_number"
        ),
        dataIndex: "partyPersonalIdentificationNumber",
        key: "partyPersonalIdentificationNumber"
      },
      {
        title: translate(
          "reporting_period_details_page.is_evaluation_candidate"
        ),
        key: "isEvaluationCandidate",
        dataIndex: "isEvaluationCandidate",
        width: "120px"
      },
      {
        title: translate("reporting_period_details_page.publication_exists"),
        key: "publicationExists",
        render: (record) => <TickBox value={record.publicationExists} />,
        width: "100px"
      },
      {
        title: translate("reporting_period_details_page.evaluation_reason"),
        dataIndex: "evaluationReason",
        key: "evaluationReason"
      },
      {
        title: translate("reporting_period_details_page.evaluation_status"),
        dataIndex: "evaluationStatus",
        key: "evaluationStatus"
      },
      {
        title: translate("reporting_period_details_page.evaluation_date"),
        dataIndex: "evaluationDate",
        key: "evaluationDate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.evaluationDate,
            b.evaluationDate
          )
      },
      {
        title: translate("reporting_period_details_page.input_available_until"),
        dataIndex: "inputAvailableUntil",
        key: "inputAvailableUntil"
      },
      {
        title: translate(
          "reporting_period_details_page.expected_reports_number"
        ),
        dataIndex: "expectedReportsNumber",
        key: "expectedReportsNumber",
        width: "150px"
      },
      {
        title: translate(
          "reporting_period_details_page.submited_reports_number"
        ),
        dataIndex: "submitedReportsNumber",
        key: "submitedReportsNumber",
        width: "150px"
      }
    ];

    return (
      <Page {...this.props}>
        <Title level={4}>
          {translate("reporting_period_details_page.title")}
        </Title>
        <ReportingPeriodOverview
          reportingPeriod={reportingPeriod}
          translate={translate}
        />
        <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider>
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={translate("reporting_period_details_page.applicants")}
            key="1"
          >
            <DataGrid
              title={translate("reporting_period_details_page.applicants")}
              translate={translate}
              columns={applicantColumns}
              dataSource={reportingPeriodApplicants}
              allowCreate={false}
              allowDelete={false}
              allowUpdate={false}
              actions={canShowApplicantDetails() ? applicantActions : []}
              loading={applicantsLoader || false}
            ></DataGrid>
          </TabPane>
        </Tabs>
      </Page>
    );
  }
}
